<div class="tw-flex tw-flex-col tw-h-full tw-bg-gray-80 tw-pb-[calc(112px+24px)] tw-overflow-scroll">
     <!-- Default view -->
     <div class="tw-flex-1 tw-p-6 tw-flex tw-flex-col">
          <div class="tw-font-lexend tw-font-bold tw-text-800 tw-text-gray-800 tw-mt-14 tw-w-4/5"
               i18n="@@yourCityAffectsYourSkinAndHair1"> Your city affects your Skin & Hair </div>
          <img class="tw-block tw-w-[75px] tw-h-[25px] tw-mt-2"
               src="https://cdn.cureskin.com/app/img/cs-icon.svg"
               alt="icon" />
          <p class="tw-font-lexend tw-text-300 tw-text-gray-800 tw-mt-6 tw-w-[70%]"
             i18n="@@tellYourDoctorWhichCityYouLive"> Tell your doctor which city you live in, so that they can give you
               the
               best treatment </p>
          <p id="how-my-city-affects-skin-and-hair-text"
             class="tw-font-lexend tw-font-bold tw-text-300 tw-text-teal-600 tw-mt-5 tw-underline"
             (click)="showInfo = !showInfo; openCitySheet()"
             i18n="@@howMyCityAffectsMySkinAndHair"> But how my city affects my skin & hair? </p>
     </div>
</div>
<footer
        class="tw-fixed tw-z-[1001] tw-h-[144px] tw-bottom-0 tw-right-0 tw-left-0 tw-pt-[26px] tw-px-6 tw-flex tw-flex-col tw-items-stretch tw-bg-white tw-rounded-t-5 sm:tw-min-h-[186px]">
     <button csButton
             id="location-btn"
             type="button"
             class="tw-w-full tw-relative proceed"
             [loading]="loading"
             (click)="getLocation()"> <span i18n="@@userYourLocation">Use Your Location</span>
     </button>
     <button csButton="muted"
             id="continue-btn"
             type="button"
             class="tw-w-full tw-relative proceed"
             [disabled]="loading"
             (click)="continue()"><span i18n="@@noThanksNew">No, Thanks</span>
     </button>
</footer>